/* PM 14 Oct 2026 · Quick view bottom sheet (JS + CSS). Loaded once per page by snippets/pm-quick-view-shell.liquid. window.__pmQV guard makes repeat loads a no-op. */
(function () {
  if (window.__pmQV) return;
  var SECTION = 'pm-quick-view';
  var cache = {}, fired = {}, open = false, token = 0, lastFocus = null, prevOverflow = '', state = 'half', closeTimer = null, drag = null, addBusy = false;

  var css = [
    '.pm-qv{position:fixed;top:0;right:0;bottom:0;left:0;z-index:10050;display:flex;align-items:flex-end;justify-content:center;background:rgba(26,26,26,.5);opacity:0;transition:opacity .2s ease;box-sizing:border-box}',
    '.pm-qv[hidden]{display:none!important}',
    '.pm-qv *,.pm-qv *::before,.pm-qv *::after{box-sizing:border-box}',
    '.pm-qv.is-open{opacity:1}',
    '.pm-qv__panel{position:relative;display:flex;flex-direction:column;width:100%;height:72vh;height:72dvh;max-height:100vh;max-height:100dvh;background:#FAF4EA;color:#3A2E26;border-radius:12px 12px 0 0;box-shadow:0 -4px 24px rgba(0,0,0,.22);overflow:hidden;transform:translateY(100%);transition:transform .26s ease,height .26s ease,border-radius .2s ease}',
    '.pm-qv.is-open .pm-qv__panel{transform:none}',
    '.pm-qv.is-full .pm-qv__panel{height:100vh;height:100dvh;border-radius:0}',
    '.pm-qv.is-drag .pm-qv__panel{transition:none}',
    '.pm-qv__panel:focus{outline:none}',
    '.pm-qv__grab{appearance:none;-webkit-appearance:none;flex:0 0 auto;display:flex;align-items:center;justify-content:center;width:100%;height:30px;margin:0;padding:0;background:none;border:0;cursor:grab;touch-action:none;-webkit-tap-highlight-color:transparent;position:relative;z-index:2}',
    '.pm-qv__grab:focus-visible{outline:2px solid #8C3A1E;outline-offset:-3px}',
    '.pm-qv__bar{display:block;width:44px;height:5px;border-radius:3px;background:#C9A27A}',
    '.pm-qv__x{appearance:none;-webkit-appearance:none;position:absolute;top:6px;right:8px;z-index:3;width:44px;height:44px;margin:0;padding:0;background:rgba(250,244,234,.92);border:0;border-radius:50%;font:inherit;font-size:2.8rem;line-height:1;color:#6B5B4E;cursor:pointer;display:flex;align-items:center;justify-content:center;-webkit-tap-highlight-color:transparent}',
    '.pm-qv__x:focus-visible{outline:2px solid #8C3A1E;outline-offset:-2px}',
    '.pm-qv__body{flex:1 1 auto;min-height:0;overflow-y:auto;-webkit-overflow-scrolling:touch;overscroll-behavior:contain}',
    '.pm-qv__sk{padding:0 0 1.6rem}',
    '.pm-qv__sk i{display:block;background:#EFE4D2;border-radius:6px;animation:pm-qv-pulse 1.2s ease-in-out infinite}',
    '.pm-qv__sk .a{width:100%;aspect-ratio:1/1;border-radius:0}',
    '.pm-qv__sk .b,.pm-qv__sk .c,.pm-qv__sk .d{margin:1.4rem 1.6rem 0}',
    '.pm-qv__sk .b{height:20px;width:70%}.pm-qv__sk .c{height:18px;width:30%}.pm-qv__sk .d{height:48px}',
    '@keyframes pm-qv-pulse{0%,100%{opacity:1}50%{opacity:.55}}',
    '@media (max-width:749px){.pm-qv.is-full .pm-qvc__slides{width:min(100%,58vh);width:min(100%,58dvh)}}',
    '@media (min-width:750px){.pm-qv{align-items:center}.pm-qv__panel{width:460px;max-width:calc(100vw - 32px);height:min(86vh,760px);transform:translateY(16px);border-radius:12px}.pm-qv.is-open .pm-qv__panel{transform:none}.pm-qv.is-full .pm-qv__panel{height:min(86vh,760px);border-radius:12px}.pm-qv__grab{display:none}.pm-qv__x{top:10px}}',
    '@media (prefers-reduced-motion:reduce){.pm-qv,.pm-qv__panel{transition:none!important}.pm-qv__sk i{animation:none}}'
  ].join('');
  var st = document.createElement('style'); st.id = 'pm-qv-css'; st.appendChild(document.createTextNode(css)); document.head.appendChild(st);

  var root = document.createElement('div');
  root.className = 'pm-qv'; root.hidden = true;
  root.innerHTML = '<div class="pm-qv__panel" role="dialog" aria-modal="true" aria-label="Quick view" tabindex="-1">' +
    '<button type="button" class="pm-qv__grab" data-grab aria-label="Expand or collapse quick view"><span class="pm-qv__bar"></span></button>' +
    '<button type="button" class="pm-qv__x" data-close aria-label="Close quick view">×</button>' +
    '<div class="pm-qv__body" data-body></div></div>';
  document.body.appendChild(root);
  var panel = root.querySelector('.pm-qv__panel'), grab = root.querySelector('[data-grab]'), body = root.querySelector('[data-body]');

  function reduced() { try { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) { return false; } }
  function desktop() { try { return window.matchMedia('(min-width: 750px)').matches; } catch (e) { return false; } }
  function vh() { return window.innerHeight || document.documentElement.clientHeight; }

  function skeleton() {
    body.setAttribute('aria-busy', 'true');
    body.innerHTML = '<div class="pm-qv__sk" role="status" aria-label="Loading"><i class="a"></i><i class="b"></i><i class="c"></i><i class="d"></i></div>';
  }

  /* ---------- fetch + cache ---------- */
  function rootUrl() { try { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; } catch (e) { return '/'; } }
  function load(handle) {
    if (cache[handle]) return cache[handle];
    var p = fetch(rootUrl() + 'products/' + encodeURIComponent(handle) + '?section_id=' + SECTION, { credentials: 'same-origin', headers: { 'Accept': 'text/html' } })
      .then(function (r) { if (!r.ok) throw new Error('qv'); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var el = doc.querySelector('[data-pm-qvc]');
        if (!el) throw new Error('qv-empty');
        return el.outerHTML;
      });
    cache[handle] = p;
    p.catch(function () { if (cache[handle] === p) delete cache[handle]; });
    return p;
  }

  /* ---------- cart helpers (same behaviour as the set-builder) ---------- */
  function getCart() { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { if (!r.ok) throw new Error('c'); return r.json(); }); }
  function notifyTheme(cart, variantId) {
    try {
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'pm-quick-view', productVariantId: variantId, cartData: cart });
      }
    } catch (e) {}
    try {
      var bubble = document.getElementById('cart-icon-bubble');
      if (bubble) {
        fetch('/?sections=cart-icon-bubble').then(function (r) { return r.json(); }).then(function (j) {
          var html = j && j['cart-icon-bubble']; if (!html) return;
          var sec = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
          if (sec) bubble.innerHTML = sec.innerHTML;
        }).catch(function () {});
      }
    } catch (e) {}
    try {
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart: cart, source: 'pm-quick-view' } }));
      document.dispatchEvent(new CustomEvent('pm:cart-changed', { detail: { cart: cart, source: 'pm-quick-view' } }));
    } catch (e) {}
  }
  function addPlain(vid) {
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: vid, quantity: 1 }] }) })
      .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
      .then(function () { return getCart(); })
      .then(function (cart) { notifyTheme(cart, vid); return true; })
      .catch(function () { return false; });
  }

  /* ---------- tracking: once per product per page view ---------- */
  function track(d) {
    var key = String(d.productId);
    if (fired[key]) return; fired[key] = 1;
    try {
      if (window.fbq) window.fbq('track', 'ViewContent', { content_ids: [String(d.variantId)], content_type: 'product', value: d.price, currency: 'INR', content_name: d.title });
    } catch (e) {}
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish('pm_quick_view', { productId: d.productId, variantId: d.variantId, handle: d.handle });
      }
    } catch (e) {}
  }

  /* ---------- content wiring ---------- */
  function initContent(el, handle) {
    var slides = el.querySelector('[data-slides]');
    if (slides) {
      var dots = el.querySelectorAll('[data-dot]'), raf = 0;
      var AUTO_MS = 3000, HOLD_MS = 6000, nextAt = 0, touching = false, autoTimer = 0;
      var hold = function (ms) { nextAt = Date.now() + (ms || HOLD_MS); };
      var go = function (i) {
        var n = slides.children.length; i = Math.max(0, Math.min(n - 1, i));
        var left = i * slides.clientWidth;
        if (reduced() || !slides.scrollTo) slides.scrollLeft = left; else slides.scrollTo({ left: left, behavior: 'smooth' });
      };
      var cur = function () { return slides.clientWidth ? Math.round(slides.scrollLeft / slides.clientWidth) : 0; };
      slides.addEventListener('scroll', function () {
        if (raf) return;
        raf = requestAnimationFrame(function () {
          raf = 0; var c = cur();
          for (var i = 0; i < dots.length; i++) { if (i === c) dots[i].setAttribute('aria-current', 'true'); else dots[i].removeAttribute('aria-current'); }
        });
      }, { passive: true });
      el.addEventListener('click', function (ev) {
        var d = ev.target.closest('[data-dot]'); if (d) { hold(); go(parseInt(d.getAttribute('data-dot'), 10) || 0); return; }
        if (ev.target.closest('[data-prev]')) { hold(); go(cur() - 1); }
        else if (ev.target.closest('[data-next]')) { hold(); go(cur() + 1); }
      });
      slides.addEventListener('keydown', function (ev) {
        if (ev.key === 'ArrowRight') { ev.preventDefault(); hold(); go(cur() + 1); }
        else if (ev.key === 'ArrowLeft') { ev.preventDefault(); hold(); go(cur() - 1); }
      });
      /* Auto-rotate: every 3 s, loops. Paused while touching, for 6 s after any manual swipe / tap, while the sheet is closed or the tab is hidden, and never with reduced motion. */
      if (slides.children.length > 1) {
        slides.addEventListener('touchstart', function () { touching = true; nextAt = Infinity; }, { passive: true });
        var untouch = function () { touching = false; hold(); };
        slides.addEventListener('touchend', untouch, { passive: true });
        slides.addEventListener('touchcancel', untouch, { passive: true });
        slides.addEventListener('pointerdown', function (ev) { if (ev.pointerType === 'mouse') hold(); });
        slides.addEventListener('wheel', function () { hold(); }, { passive: true });
        el.addEventListener('focusin', function (ev) { if (ev.target.closest && ev.target.closest('[data-slides],[data-dot],[data-prev],[data-next]')) hold(); });
        var onVis = function () { if (!document.hidden) hold(AUTO_MS); };
        document.addEventListener('visibilitychange', onVis);
        hold(AUTO_MS);
        autoTimer = setInterval(function () {
          if (!el.isConnected) { clearInterval(autoTimer); document.removeEventListener('visibilitychange', onVis); return; }
          if (!open || document.hidden || touching || reduced()) { hold(AUTO_MS); return; }
          if (Date.now() < nextAt) return;
          hold(AUTO_MS);
          var n = slides.children.length;
          go((cur() + 1) % n);
        }, 250);
      }
    }
    var btn = el.querySelector('[data-qv-add]');
    if (btn) {
      var g = el.getAttribute('data-group'), api = window.__pmOcApi;
      var mode = (api && g && api.group === g && typeof api.add === 'function') ? 'set' : 'cart';
      var label = mode === 'set' ? '+ Add to set' : 'Add to cart';
      btn.textContent = label; btn.setAttribute('data-mode', mode);
      btn.setAttribute('aria-label', (mode === 'set' ? 'Add to your set: ' : 'Add to cart: ') + (el.getAttribute('data-title') || ''));
      var errEl = el.querySelector('[data-qv-err]');
      btn.addEventListener('click', function () {
        if (addBusy || btn.getAttribute('aria-disabled') === 'true') return;
        addBusy = true; btn.setAttribute('aria-disabled', 'true'); if (errEl) errEl.hidden = true;
        var vid = parseInt(btn.getAttribute('data-vid'), 10);
        var run = mode === 'set' ? api.add(vid) : addPlain(vid);
        Promise.resolve(run).then(function (ok) {
          addBusy = false;
          if (ok) {
            btn.textContent = 'Added ✓'; btn.classList.add('is-done');
            setTimeout(function () { btn.textContent = label; btn.classList.remove('is-done'); btn.removeAttribute('aria-disabled'); }, 1600);
          } else {
            btn.removeAttribute('aria-disabled');
            if (ok === false && errEl) errEl.hidden = false;
          }
        }, function () { addBusy = false; btn.removeAttribute('aria-disabled'); if (errEl) errEl.hidden = false; });
      });
    }
    track({
      productId: parseInt(el.getAttribute('data-product-id'), 10) || el.getAttribute('data-product-id'),
      variantId: parseInt(el.getAttribute('data-variant-id'), 10) || el.getAttribute('data-variant-id'),
      handle: el.getAttribute('data-handle') || handle,
      title: el.getAttribute('data-title') || '',
      price: (parseInt(el.getAttribute('data-price'), 10) || 0) / 100
    });
  }

  /* ---------- sheet state ---------- */
  function setState(s) {
    state = s;
    if (s === 'full') root.classList.add('is-full'); else root.classList.remove('is-full');
  }
  function snapTo(target) {
    var px = target === 'full' ? vh() : Math.round(vh() * 0.72);
    root.classList.remove('is-drag');
    if (reduced()) { panel.style.height = ''; setState(target); return; }
    panel.style.height = panel.getBoundingClientRect().height + 'px';
    void panel.offsetHeight;
    panel.style.height = px + 'px';
    setState(target);
    setTimeout(function () { if (open && state === target) panel.style.height = ''; }, 320);
  }

  function focusables() {
    return Array.prototype.filter.call(panel.querySelectorAll('button, a[href], [tabindex="0"]'), function (n) { return !n.disabled && n.getAttribute('aria-disabled') !== 'true' && n.offsetParent !== null; });
  }

  function openQV(handle, url, opener) {
    if (!handle) return false;
    clearTimeout(closeTimer);
    var my = ++token;
    if (!open) {
      lastFocus = opener || document.activeElement;
      prevOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      root.hidden = false;
      panel.style.height = '';
      setState('half');
      void root.offsetHeight;
      root.classList.add('is-open');
      open = true;
    }
    skeleton();
    body.scrollTop = 0;
    try { panel.focus({ preventScroll: true }); } catch (e) { panel.focus(); }
    load(handle).then(function (html) {
      if (my !== token || !open) return;
      body.removeAttribute('aria-busy');
      body.innerHTML = html;
      var el = body.querySelector('[data-pm-qvc]');
      if (!el) throw new Error('qv');
      panel.setAttribute('aria-label', el.getAttribute('data-title') || 'Quick view');
      initContent(el, handle);
    }).catch(function () {
      if (my !== token) return;
      closeQV(true);
      if (url) { window.location.href = url; }
    });
    return true;
  }
  function closeQV(noFocus) {
    if (!open) return;
    open = false; token++;
    root.classList.remove('is-open', 'is-drag');
    panel.style.height = '';
    document.body.style.overflow = prevOverflow;
    var done = function () { if (!open) { root.hidden = true; setState('half'); body.innerHTML = ''; } };
    if (reduced()) done(); else closeTimer = setTimeout(done, 280);
    var t = lastFocus; lastFocus = null;
    if (!noFocus && t && document.contains(t) && t !== document.body && t.focus) { try { t.focus({ preventScroll: true }); } catch (e) { t.focus(); } }
  }

  /* ---------- drag handle ---------- */
  var THR = 60, VEL = 0.45;
  grab.addEventListener('pointerdown', function (ev) {
    if (desktop() || (ev.pointerType === 'mouse' && ev.button !== 0)) return;
    drag = { id: ev.pointerId, y0: ev.clientY, h0: panel.getBoundingClientRect().height, start: state, moved: false, s: [{ t: ev.timeStamp, y: ev.clientY }] };
    panel.style.height = drag.h0 + 'px';
    root.classList.add('is-drag');
    try { grab.setPointerCapture(ev.pointerId); } catch (e) {}
  });
  grab.addEventListener('pointermove', function (ev) {
    if (!drag || ev.pointerId !== drag.id) return;
    var dy = ev.clientY - drag.y0;
    if (Math.abs(dy) > 4) drag.moved = true;
    if (!drag.moved) return;
    ev.preventDefault();
    var h = Math.max(80, Math.min(vh(), drag.h0 - dy));
    panel.style.height = h + 'px';
    drag.s.push({ t: ev.timeStamp, y: ev.clientY });
    while (drag.s.length > 2 && ev.timeStamp - drag.s[0].t > 120) drag.s.shift();
  });
  function endDrag(ev, cancelled) {
    if (!drag || ev.pointerId !== drag.id) return;
    var d = drag; drag = null;
    try { grab.releasePointerCapture(ev.pointerId); } catch (e) {}
    root.classList.remove('is-drag');
    var dy = ev.clientY - d.y0, a = d.s[0], b = d.s[d.s.length - 1];
    var v = (b.t - a.t) > 8 ? (b.y - a.y) / (b.t - a.t) : 0;  /* px per ms, positive = moving down */
    if (cancelled) { snapTo(d.start); return; }
    if (!d.moved) { d.tap = true; snapTo(d.start === 'half' ? 'full' : 'half'); return; }
    if (d.start === 'half') {
      if (v < -VEL || dy < -THR) snapTo('full');
      else if (v > VEL || dy > THR) closeQV();
      else snapTo('half');
    } else {
      if (v > VEL || dy > THR) snapTo('half'); else snapTo('full');
    }
  }
  grab.addEventListener('pointerup', function (ev) { endDrag(ev, false); });
  grab.addEventListener('pointercancel', function (ev) { endDrag(ev, true); });
  grab.addEventListener('click', function (ev) { if (ev.detail === 0 && !desktop()) snapTo(state === 'half' ? 'full' : 'half'); });
  window.addEventListener('resize', function () { if (open && !drag) panel.style.height = ''; });

  /* ---------- backdrop, close button, keys ---------- */
  root.addEventListener('click', function (ev) {
    if (ev.target === root) { closeQV(); return; }
    if (ev.target.closest('[data-close]')) closeQV();
  });
  root.addEventListener('touchmove', function (ev) { if (ev.target === root) ev.preventDefault(); }, { passive: false });
  /* Capture phase on window: the set-builder sheet also listens for Esc / Tab on document, and must not react while this is on top */
  window.addEventListener('keydown', function (ev) {
    if (!open) return;
    if (ev.key === 'Escape' || ev.key === 'Esc') { ev.preventDefault(); ev.stopPropagation(); ev.stopImmediatePropagation(); closeQV(); return; }
    if (ev.key === 'Tab') {
      ev.stopPropagation(); ev.stopImmediatePropagation();
      var f = focusables(); if (!f.length) { ev.preventDefault(); panel.focus(); return; }
      var first = f[0], last = f[f.length - 1], act = document.activeElement;
      if (!panel.contains(act) || act === panel) { ev.preventDefault(); (ev.shiftKey ? last : first).focus(); }
      else if (ev.shiftKey && act === first) { ev.preventDefault(); last.focus(); }
      else if (!ev.shiftKey && act === last) { ev.preventDefault(); first.focus(); }
    }
  }, true);
  window.addEventListener('pageshow', function (ev) { if (ev.persisted && open) closeQV(true); });

  /* ---------- click interception used by every trigger ---------- */
  function handleFromHref(href) {
    try {
      var u = new URL(href, location.href);
      if (u.origin !== location.origin) return '';
      var m = u.pathname.match(/\/products\/([^\/?#]+)/);
      return m ? decodeURIComponent(m[1]) : '';
    } catch (e) { return ''; }
  }
  function intercept(ev, a) {
    if (!a || ev.defaultPrevented) return false;
    if (ev.button !== 0 || ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.altKey) return false;
    var tg = a.getAttribute('target'); if (tg && tg !== '_self') return false;
    var h = handleFromHref(a.href); if (!h) return false;
    ev.preventDefault();
    return openQV(h, a.href, a);
  }

  window.__pmQV = { ready: true, open: openQV, close: function () { closeQV(); }, isOpen: function () { return open; }, intercept: intercept };
})();
